module.exports = __webpack_public_path__ + "static/media/table_column_name_dropdown.8a278327.png";